// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainPage_mainPage__Lqjnl > main {
  display: flex;
  flex-direction: column;
  gap: 5.2083333333vw;
}

.MainPage_container__\\+LDn4 {
  position: relative;
}

.MainPage_subtitle__bVoHM {
  font-family: "Montserrat Alternates";
  font-size: 7.5rem;
  line-height: 7.5rem;
}

.MainPage_titleSection__zYfmJ {
  padding: 3.6458333333vw 0 2.6041666667vw;
  display: flex;
  flex-direction: column;
  color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 0 0 3rem 3rem;
}
.MainPage_titleSection__zYfmJ .MainPage_header__7rpjJ {
  padding: 0 0 5.7291666667vw;
}
.MainPage_titleSection__zYfmJ .MainPage_titleBlock__TGgo\\+ {
  margin: 0 auto 0 0;
  padding: 2.5rem 0 2.5rem calc((100vw - 1400px) / 2);
  display: flex;
  justify-content: flex-end;
  width: max-content;
  background: var(--blue-dark);
  border-radius: 0px 3rem 3rem 0px;
}
.MainPage_titleSection__zYfmJ .MainPage_titleBlock__TGgo\\+ h1 {
  font-family: "Montserrat Alternates";
  font-size: 8.5rem;
  line-height: 8.5rem;
}
.MainPage_titleSection__zYfmJ .MainPage_textBlock__TO225 {
  padding: 0.7rem 3.6rem;
  align-self: center;
  width: 52%;
  background: var(--blue-dark);
  border-radius: 0rem 0rem 2rem 1rem;
}
.MainPage_titleSection__zYfmJ .MainPage_textBlock__TO225 > span:nth-of-type(1) {
  font-size: 2.4rem;
}
.MainPage_titleSection__zYfmJ .MainPage_textBlock__TO225 > span:nth-of-type(2) {
  padding: 0.4rem 1rem;
  font-size: 3.4rem;
  background: var(--red);
  border-radius: 0.8rem;
  transform: rotate(-2.492deg);
}
.MainPage_titleSection__zYfmJ .MainPage_iconsBlock__Oka75 {
  margin: 0 0 4rem;
  padding: 4.6rem 6rem;
  align-self: flex-end;
  display: flex;
  gap: 2rem;
  width: 100%;
  background: var(--blue-dark);
  border-radius: 3rem;
}
.MainPage_titleSection__zYfmJ .MainPage_iconsBlock__Oka75 > div {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 17rem;
}
.MainPage_titleSection__zYfmJ .MainPage_iconsBlock__Oka75 > div > svg {
  width: 10rem;
  height: 10rem;
}
.MainPage_titleSection__zYfmJ .MainPage_btn__ZS2Uk {
  padding: 3rem;
  align-self: center;
}
.MainPage_titleSection__zYfmJ .MainPage_img__dYlPd {
  position: absolute;
  bottom: 0;
  right: -17rem;
  width: 66rem;
  height: 60rem;
}

.MainPage_advantagesSection__gVSBQ {
  display: flex;
  flex-direction: column;
  gap: 6rem;
}
.MainPage_advantagesSection__gVSBQ .MainPage_subtitleBlock__PiAzH {
  margin: 0 0 0 calc((100vw - 1400px) / 2);
  padding: 2.5rem 260px 10rem 8rem;
  background: var(--blue-dark);
  border-radius: 3rem 0 0 3rem;
}
.MainPage_advantagesSection__gVSBQ .MainPage_subtitleBlock__PiAzH h3 {
  color: #fff;
}
.MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 {
  display: flex;
}
.MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 > img {
  position: absolute;
  bottom: -6rem;
  left: 10rem;
  width: 76rem;
  height: 55rem;
}
.MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 > ul {
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4rem;
}
.MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 > ul > li {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 48rem;
  color: var(--blue-dark);
  font-family: "Montserrat Alternates";
  font-size: 3rem;
}
.MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 > ul > li > span {
  font-family: "Raleway";
  font-size: 1.8rem;
}

.MainPage_instructionSection__gm43W > h3 {
  margin: 0 0 6rem;
}
.MainPage_instructionSection__content__slGp9 {
  display: grid;
  grid-template-columns: 1fr 40%;
  gap: 5rem;
  align-items: center;
}
.MainPage_instructionSection__content__slGp9 > video {
  width: 100%;
  height: 44rem;
}
.MainPage_instructionSection__content__slGp9 > div {
  display: flex;
  gap: 4rem;
  height: 100%;
  max-height: 23rem;
}
.MainPage_instructionSection__content__slGp9 > div > div:nth-of-type(1) {
  width: 1rem;
  height: 100%;
  border-radius: 2px;
  background: linear-gradient(0deg, #ace6fd 0%, #7190e3 11.51%, #d098a9 26.3%, #af8ef5 39.62%, #6fbbea 54.14%, #d97da3 68.6%, #e98490 83.88%, #fccc97 100%);
}
.MainPage_instructionSection__content__slGp9 > div > div:nth-of-type(2) {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6rem;
  font-family: "Montserrat Alternates";
  color: var(--blue-dark);
}

.MainPage_testSection__nQfXK {
  display: grid;
  grid-template-columns: 40% 1fr;
  gap: 5.2083333333vw;
  align-items: center;
}
.MainPage_testSection__nQfXK > div:nth-of-type(1) {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}
.MainPage_testSection__nQfXK > div:nth-of-type(1) > button {
  padding: 3rem 8rem;
  width: max-content;
}
.MainPage_testSection__nQfXK > svg {
  width: 50rem;
  height: 46rem;
}

@media (min-width: 1920px) {
  .MainPage_mainPage__Lqjnl > main {
    gap: 10rem;
  }
  .MainPage_titleSection__zYfmJ {
    padding: 7rem 0 5rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_header__7rpjJ {
    padding: 0 0 11rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_titleBlock__TGgo\\+ {
    padding: 2.5rem 0 2.5rem 260px;
  }
  .MainPage_advantagesSection__gVSBQ .MainPage_subtitleBlock__PiAzH {
    margin: 0 0 0 260px;
  }
  .MainPage_testSection__nQfXK {
    gap: 10rem;
  }
}
@media (max-width: 1400px) {
  .MainPage_titleSection__zYfmJ .MainPage_titleBlock__TGgo\\+ {
    padding: 2.5rem 0 2.5rem calc((100vw - 1100px) / 2);
  }
  .MainPage_advantagesSection__gVSBQ .MainPage_subtitleBlock__PiAzH {
    margin: 0 0 0 calc((100vw - 1100px) / 2);
    padding: 2.5rem calc((100vw - 1100px) / 2) 10rem 8rem;
  }
  .MainPage_instructionSection__content__slGp9 > video {
    width: 100%;
    height: 345.7142857143px;
  }
}
@media (max-width: 1100px) {
  .MainPage_subtitle__bVoHM {
    font-size: 6.5rem;
    line-height: 6.5rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_titleBlock__TGgo\\+ {
    padding: 2.5rem 0 2.5rem calc((100vw - 800px) / 2);
  }
  .MainPage_titleSection__zYfmJ .MainPage_titleBlock__TGgo\\+ h1 {
    font-size: 7rem;
    line-height: 7rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_textBlock__TO225 > span:nth-of-type(1) {
    font-size: 2rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_textBlock__TO225 > span:nth-of-type(2) {
    font-size: 3rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_iconsBlock__Oka75 {
    padding: 3rem 4rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_iconsBlock__Oka75 > div {
    max-width: 12rem;
    font-size: 1.5rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_iconsBlock__Oka75 > div > svg {
    width: 8rem;
    height: 8rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_img__dYlPd {
    width: 56rem;
    height: 50rem;
  }
  .MainPage_advantagesSection__gVSBQ .MainPage_subtitleBlock__PiAzH {
    margin: 0 0 0 calc((100vw - 800px) / 2);
    padding: 2.5rem calc((100vw - 800px) / 2) 10rem 8rem;
  }
  .MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 > img {
    left: 2rem;
    width: 56rem;
    height: 50rem;
  }
  .MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 > ul > li {
    max-width: 40rem;
    font-size: 2.5rem;
  }
  .MainPage_instructionSection__content__slGp9 > video {
    width: 100%;
    height: 251.4285714286px;
  }
}
@media (max-width: 800px) {
  .MainPage_mainPage__Lqjnl > main {
    gap: 5rem;
  }
  .MainPage_subtitle__bVoHM {
    font-size: 3.6rem;
    line-height: 3.6rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_titleBlock__TGgo\\+ {
    margin: 0 4vw 0 0;
    max-width: 96vw;
  }
  .MainPage_titleSection__zYfmJ .MainPage_titleBlock__TGgo\\+ h1 {
    font-size: 3.6rem;
    line-height: 3.6rem;
    hyphens: auto;
  }
  .MainPage_titleSection__zYfmJ .MainPage_textBlock__TO225 {
    margin: 0.5rem 0;
    grid-template-columns: 90% 1fr;
    align-self: flex-start;
    width: 100%;
    border-radius: 0rem 2rem 2rem 1rem;
    z-index: 1;
    position: relative;
  }
  .MainPage_titleSection__zYfmJ .MainPage_textBlock__TO225 > span:nth-of-type(1) {
    font-size: 1.6rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_textBlock__TO225 > span:nth-of-type(2) {
    position: absolute;
    bottom: -2rem;
    right: 16vw;
    font-size: 1.6rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_iconsBlock__Oka75 {
    margin: 0 0 2rem;
    padding: 3rem 1.5rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    z-index: 1;
  }
  .MainPage_titleSection__zYfmJ .MainPage_iconsBlock__Oka75 > div {
    max-width: 12rem;
    font-size: 1.5rem;
  }
  .MainPage_titleSection__zYfmJ .MainPage_iconsBlock__Oka75 > div > svg {
    width: 10.6666666667vw;
    height: 10.6666666667vw;
  }
  .MainPage_titleSection__zYfmJ .MainPage_img__dYlPd {
    top: 0;
    right: -24%;
    width: 82.6666666667vw;
    height: 74.6666666667vw;
  }
  .MainPage_advantagesSection__gVSBQ {
    gap: 0;
  }
  .MainPage_advantagesSection__gVSBQ .MainPage_subtitleBlock__PiAzH {
    margin: 0 0 0 4vw;
    padding: 2.5rem 0 4rem 2rem;
  }
  .MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 {
    margin: -4rem 0 0;
    gap: 2rem;
  }
  .MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 > img {
    position: relative;
    bottom: 0;
    max-width: 48rem;
    max-height: 42rem;
    width: 80vw;
    height: 64vw;
  }
  .MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 > ul {
    align-items: flex-start;
  }
  .MainPage_advantagesSection__gVSBQ > .MainPage_container__\\+LDn4 > ul > li {
    font-size: 1.8rem;
  }
  .MainPage_instructionSection__gm43W > h3 {
    margin: 0 0 4rem;
  }
  .MainPage_instructionSection__content__slGp9 {
    grid-template-columns: 1fr;
  }
  .MainPage_instructionSection__content__slGp9 > video {
    width: 100%;
    height: 55.6962025316vw;
  }
  .MainPage_testSection__nQfXK {
    grid-template-columns: 1fr;
    grid-template-areas: "img" "text";
  }
  .MainPage_testSection__nQfXK > div:nth-of-type(1) {
    grid-area: text;
  }
  .MainPage_testSection__nQfXK > svg {
    grid-area: img;
    max-width: 35rem;
    max-height: 33rem;
    width: 56vw;
    height: 50.6666666667vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/MainPage/MainPage.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAAF;;AAIA;EACC,kBAAA;AADD;;AAIA;EACC,oCAAA;EAGA,iBAAA;EACA,mBAAA;AAHD;;AAMA;EACC,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,4BAAA;AAHD;AAKC;EACC,2BAAA;AAHF;AAMC;EACC,kBAAA;EACA,mDAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gCAAA;AAJF;AAME;EAGC,oCAAA;EAGA,iBAAA;EACA,mBAAA;AARH;AAYC;EAEC,sBAAA;EACA,kBAAA;EAIA,UAAA;EACA,4BAAA;EACA,kCAAA;AAdF;AAgBE;EACC,iBAAA;AAdH;AAgBE;EACC,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;AAdH;AAkBC;EACC,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,4BAAA;EACA,mBAAA;AAhBF;AAkBE;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAhBH;AAkBG;EACC,YAAA;EACA,aAAA;AAhBJ;AAqBC;EACC,aAAA;EACA,kBAAA;AAnBF;AAsBC;EACC,kBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AApBF;;AA0BA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAvBD;AAyBC;EACC,wCAAA;EACA,gCAAA;EAEA,4BAAA;EACA,4BAAA;AAxBF;AA0BE;EACC,WAAA;AAxBH;AA4BC;EACC,aAAA;AA1BF;AA4BE;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AA1BH;AA6BE;EAEC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;AA5BH;AA8BG;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,oCAAA;EACA,eAAA;AA5BJ;AA8BI;EACC,sBAAA;EACA,iBAAA;AA5BL;;AAoCC;EACC,gBAAA;AAjCF;AAoCC;EACC,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAlCF;AAoCE;EACC,WAAA;EACA,aAAA;AAlCH;AAqCE;EACC,aAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;AAnCH;AAqCG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yJAAA;AAnCJ;AA+CG;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,oCAAA;EACA,uBAAA;AA7CJ;;AAmDA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAhDD;AAkDC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAhDF;AAkDE;EACC,kBAAA;EACA,kBAAA;AAhDH;AAmDC;EACC,YAAA;EACA,aAAA;AAjDF;;AAqDA;EACC;IACC,UAAA;EAlDA;EAwDD;IACC,oBAAA;EAtDA;EAwDA;IACC,kBAAA;EAtDD;EAwDA;IACC,8BAAA;EAtDD;EA+DA;IACC,mBAAA;EA7DD;EAgED;IACC,UAAA;EA9DA;AACF;AAiEA;EAEE;IACC,mDAAA;EAhED;EAoEA;IACC,wCAAA;IACA,qDAAA;EAlED;EAwEC;IACC,WAAA;IACA,wBAAA;EAtEF;AACF;AA2EA;EACC;IACC,iBAAA;IACA,mBAAA;EAzEA;EA4EA;IACC,kDAAA;EA1ED;EA4EC;IACC,eAAA;IACA,iBAAA;EA1EF;EAkFC;IACC,eAAA;EAhFF;EAkFC;IACC,eAAA;EAhFF;EAoFA;IACC,kBAAA;EAlFD;EAoFC;IACC,gBAAA;IACA,iBAAA;EAlFF;EAoFE;IACC,WAAA;IACA,YAAA;EAlFH;EAuFA;IAEC,YAAA;IACA,aAAA;EAtFD;EA0FA;IACC,uCAAA;IACA,oDAAA;EAxFD;EA4FC;IACC,UAAA;IACA,YAAA;IACA,aAAA;EA1FF;EA4FC;IACC,gBAAA;IACA,iBAAA;EA1FF;EAiGC;IACC,WAAA;IACA,wBAAA;EA/FF;AACF;AAqGA;EAEE;IACC,SAAA;EApGD;EAwGD;IACC,iBAAA;IACA,mBAAA;EAtGA;EA0GA;IACC,iBAAA;IACA,eAAA;EAxGD;EA0GC;IACC,iBAAA;IACA,mBAAA;IACA,aAAA;EAxGF;EA4GA;IAEC,gBAAA;IACA,8BAAA;IACA,sBAAA;IACA,WAAA;IACA,kCAAA;IACA,UAAA;IACA,kBAAA;EA3GD;EA6GC;IACC,iBAAA;EA3GF;EA6GC;IACC,kBAAA;IACA,aAAA;IACA,WAAA;IACA,iBAAA;EA3GF;EA+GA;IACC,gBAAA;IACA,oBAAA;IACA,aAAA;IACA,8BAAA;IACA,UAAA;EA7GD;EA+GC;IACC,gBAAA;IACA,iBAAA;EA7GF;EA+GE;IACC,sBAAA;IACA,uBAAA;EA7GH;EAkHA;IACC,MAAA;IACA,WAAA;IACA,sBAAA;IACA,uBAAA;EAhHD;EAoHD;IACC,MAAA;EAlHA;EAoHA;IACC,iBAAA;IACA,2BAAA;EAlHD;EAqHA;IACC,iBAAA;IACA,SAAA;EAnHD;EAqHC;IACC,kBAAA;IACA,SAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;EAnHF;EAsHC;IACC,uBAAA;EApHF;EAsHE;IACC,iBAAA;EApHH;EA2HA;IACC,gBAAA;EAzHD;EA4HA;IACC,0BAAA;EA1HD;EA2HC;IACC,WAAA;IACA,uBAAA;EAzHF;EA8HD;IACC,0BAAA;IACA,iCAAA;EA5HA;EA8HA;IACC,eAAA;EA5HD;EA8HA;IACC,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;IACA,uBAAA;EA5HD;AACF","sourcesContent":[".mainPage {\n\t& > main {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: calc(100vw / 1920 * 100);\n\t}\n}\n\n.container {\n\tposition: relative;\n}\n\n.subtitle {\n\tfont-family: 'Montserrat Alternates';\n\t// font-size: calc(100vw / 1920 * 75);\n\t// line-height: calc(100vw / 1920 * 75);\n\tfont-size: 7.5rem;\n\tline-height: 7.5rem;\n}\n\n.titleSection {\n\tpadding: calc(100vw / 1920 * 70) 0 calc(100vw / 1920 * 50);\n\tdisplay: flex;\n\tflex-direction: column;\n\tcolor: #fff;\n\tbackground-image: url(../../../images/background.png);\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tborder-radius: 0 0 3rem 3rem;\n\n\t.header {\n\t\tpadding: 0 0 calc(100vw / 1920 * 110);\n\t}\n\n\t.titleBlock {\n\t\tmargin: 0 auto 0 0;\n\t\tpadding: 2.5rem 0 2.5rem calc((100vw - 1400px) / 2);\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\twidth: max-content;\n\t\tbackground: var(--blue-dark);\n\t\tborder-radius: 0px 3rem 3rem 0px;\n\n\t\th1 {\n\t\t\t// margin: 0 0 0;\n\t\t\t// color: #fff;\n\t\t\tfont-family: 'Montserrat Alternates';\n\t\t\t// font-size: calc(100vw / 1920 * 85);\n\t\t\t// line-height: calc(100vw / 1920 * 85);\n\t\t\tfont-size: 8.5rem;\n\t\t\tline-height: 8.5rem;\n\t\t}\n\t}\n\n\t.textBlock {\n\t\t// margin: 0.5rem 0;\n\t\tpadding: 0.7rem 3.6rem;\n\t\talign-self: center;\n\t\t// display: grid;\n\t\t// grid-template-columns: 40% 35% 1fr;\n\t\t// gap: 2rem;\n\t\twidth: 52%;\n\t\tbackground: var(--blue-dark);\n\t\tborder-radius: 0rem 0rem 2rem 1rem;\n\n\t\t& > span:nth-of-type(1) {\n\t\t\tfont-size: 2.4rem;\n\t\t}\n\t\t& > span:nth-of-type(2) {\n\t\t\tpadding: 0.4rem 1rem;\n\t\t\tfont-size: 3.4rem;\n\t\t\tbackground: var(--red);\n\t\t\tborder-radius: 0.8rem;\n\t\t\ttransform: rotate(-2.492deg);\n\t\t}\n\t}\n\n\t.iconsBlock {\n\t\tmargin: 0 0 4rem;\n\t\tpadding: 4.6rem 6rem;\n\t\talign-self: flex-end;\n\t\tdisplay: flex;\n\t\tgap: 2rem;\n\t\twidth: 100%;\n\t\tbackground: var(--blue-dark);\n\t\tborder-radius: 3rem;\n\n\t\t& > div {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 1.5rem;\n\t\t\tmax-width: 17rem;\n\n\t\t\t& > svg {\n\t\t\t\twidth: 10rem;\n\t\t\t\theight: 10rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t.btn {\n\t\tpadding: 3rem;\n\t\talign-self: center;\n\t}\n\n\t.img {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tright: -17rem;\n\t\twidth: 66rem;\n\t\theight: 60rem;\n\t\t// width: calc(100vw / 1920 * 660);\n\t\t// height: calc(100vw / 1920 * 600);\n\t}\n}\n\n.advantagesSection {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 6rem;\n\n\t.subtitleBlock {\n\t\tmargin: 0 0 0 calc((100vw - 1400px) / 2);\n\t\tpadding: 2.5rem calc((1920px - 1400px) / 2) 10rem 8rem;\n\n\t\tbackground: var(--blue-dark);\n\t\tborder-radius: 3rem 0 0 3rem;\n\n\t\th3 {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\n\t& > .container {\n\t\tdisplay: flex;\n\n\t\t& > img {\n\t\t\tposition: absolute;\n\t\t\tbottom: -6rem;\n\t\t\tleft: 10rem;\n\t\t\twidth: 76rem;\n\t\t\theight: 55rem;\n\t\t}\n\n\t\t& > ul {\n\t\t\t// margin: 0 0 0 auto;\n\t\t\tpadding: 0;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-end;\n\t\t\tgap: 4rem;\n\n\t\t\t& > li {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 1rem;\n\t\t\t\tmax-width: 48rem;\n\t\t\t\tcolor: var(--blue-dark);\n\t\t\t\tfont-family: 'Montserrat Alternates';\n\t\t\t\tfont-size: 3rem;\n\n\t\t\t\t& > span {\n\t\t\t\t\tfont-family: 'Raleway';\n\t\t\t\t\tfont-size: 1.8rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.instructionSection {\n\t& > h3 {\n\t\tmargin: 0 0 6rem;\n\t}\n\n\t&__content {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 40%;\n\t\tgap: 5rem;\n\t\talign-items: center;\n\n\t\t& > video {\n\t\t\twidth: 100%;\n\t\t\theight: 44rem;\n\t\t}\n\n\t\t& > div {\n\t\t\tdisplay: flex;\n\t\t\tgap: 4rem;\n\t\t\theight: 100%;\n\t\t\tmax-height: 23rem;\n\n\t\t\t& > div:nth-of-type(1) {\n\t\t\t\twidth: 1rem;\n\t\t\t\theight: 100%;\n\t\t\t\tborder-radius: 2px;\n\t\t\t\tbackground: linear-gradient(\n\t\t\t\t\t0deg,\n\t\t\t\t\t#ace6fd 0%,\n\t\t\t\t\t#7190e3 11.51%,\n\t\t\t\t\t#d098a9 26.3%,\n\t\t\t\t\t#af8ef5 39.62%,\n\t\t\t\t\t#6fbbea 54.14%,\n\t\t\t\t\t#d97da3 68.6%,\n\t\t\t\t\t#e98490 83.88%,\n\t\t\t\t\t#fccc97 100%\n\t\t\t\t);\n\t\t\t}\n\t\t\t& > div:nth-of-type(2) {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tgap: 6rem;\n\t\t\t\tfont-family: 'Montserrat Alternates';\n\t\t\t\tcolor: var(--blue-dark);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.testSection {\n\tdisplay: grid;\n\tgrid-template-columns: 40% 1fr;\n\tgap: calc(100vw / 1920 * 100);\n\talign-items: center;\n\n\t& > div:nth-of-type(1) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 3rem;\n\n\t\t& > button {\n\t\t\tpadding: 3rem 8rem;\n\t\t\twidth: max-content;\n\t\t}\n\t}\n\t& > svg {\n\t\twidth: 50rem;\n\t\theight: 46rem;\n\t}\n}\n\n@media (min-width: 1920px) {\n\t.mainPage > main {\n\t\tgap: 10rem;\n\t}\n\t// .subtitle {\n\t// \tfont-size: 7.5rem;\n\t// \tline-height: 7.5rem;\n\t// }\n\t.titleSection {\n\t\tpadding: 7rem 0 5rem;\n\n\t\t.header {\n\t\t\tpadding: 0 0 11rem;\n\t\t}\n\t\t.titleBlock {\n\t\t\tpadding: 2.5rem 0 2.5rem calc((1920px - 1400px) / 2);\n\n\t\t\t// h1 {\n\t\t\t// \tfont-size: 9rem;\n\t\t\t// \tline-height: 9rem;\n\t\t\t// }\n\t\t}\n\t}\n\t.advantagesSection {\n\t\t.subtitleBlock {\n\t\t\tmargin: 0 0 0 calc((1920px - 1400px) / 2);\n\t\t}\n\t}\n\t.testSection {\n\t\tgap: 10rem;\n\t}\n}\n\n@media (max-width: 1400px) {\n\t.titleSection {\n\t\t.titleBlock {\n\t\t\tpadding: 2.5rem 0 2.5rem calc((100vw - 1100px) / 2);\n\t\t}\n\t}\n\t.advantagesSection {\n\t\t.subtitleBlock {\n\t\t\tmargin: 0 0 0 calc((100vw - 1100px) / 2);\n\t\t\tpadding: 2.5rem calc((100vw - 1100px) / 2) 10rem 8rem;\n\t\t}\n\t}\n\n\t.instructionSection {\n\t\t&__content {\n\t\t\t& > video {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: calc((440 * 1100px) / 1400);\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 1100px) {\n\t.subtitle {\n\t\tfont-size: 6.5rem;\n\t\tline-height: 6.5rem;\n\t}\n\t.titleSection {\n\t\t.titleBlock {\n\t\t\tpadding: 2.5rem 0 2.5rem calc((100vw - 800px) / 2);\n\n\t\t\th1 {\n\t\t\t\tfont-size: 7rem;\n\t\t\t\tline-height: 7rem;\n\t\t\t}\n\t\t}\n\n\t\t.textBlock {\n\t\t\t// gap: 1.5rem;\n\t\t\t// width: 90%;\n\n\t\t\t& > span:nth-of-type(1) {\n\t\t\t\tfont-size: 2rem;\n\t\t\t}\n\t\t\t& > span:nth-of-type(2) {\n\t\t\t\tfont-size: 3rem;\n\t\t\t}\n\t\t}\n\n\t\t.iconsBlock {\n\t\t\tpadding: 3rem 4rem;\n\n\t\t\t& > div {\n\t\t\t\tmax-width: 12rem;\n\t\t\t\tfont-size: 1.5rem;\n\n\t\t\t\t& > svg {\n\t\t\t\t\twidth: 8rem;\n\t\t\t\t\theight: 8rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.img {\n\t\t\t// right: -10%;\n\t\t\twidth: 56rem;\n\t\t\theight: 50rem;\n\t\t}\n\t}\n\t.advantagesSection {\n\t\t.subtitleBlock {\n\t\t\tmargin: 0 0 0 calc((100vw - 800px) / 2);\n\t\t\tpadding: 2.5rem calc((100vw - 800px) / 2) 10rem 8rem;\n\t\t}\n\n\t\t& > .container {\n\t\t\t& > img {\n\t\t\t\tleft: 2rem;\n\t\t\t\twidth: 56rem;\n\t\t\t\theight: 50rem;\n\t\t\t}\n\t\t\t& > ul > li {\n\t\t\t\tmax-width: 40rem;\n\t\t\t\tfont-size: 2.5rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t.instructionSection {\n\t\t&__content {\n\t\t\t& > video {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: calc((440 * 800px) / 1400);\n\t\t\t}\n\t\t}\n\t}\n}\n\n// mobile\n@media (max-width: 800px) {\n\t.mainPage {\n\t\t& > main {\n\t\t\tgap: 5rem;\n\t\t}\n\t}\n\n\t.subtitle {\n\t\tfont-size: 3.6rem;\n\t\tline-height: 3.6rem;\n\t}\n\n\t.titleSection {\n\t\t.titleBlock {\n\t\t\tmargin: 0 calc(100vw / 375 * 15) 0 0;\n\t\t\tmax-width: calc(100vw - (100vw / 375 * 15));\n\t\t\t// padding: 2.5rem 0 2.5rem calc((100vw - 800px) / 2);\n\t\t\th1 {\n\t\t\t\tfont-size: 3.6rem;\n\t\t\t\tline-height: 3.6rem;\n\t\t\t\thyphens: auto;\n\t\t\t}\n\t\t}\n\n\t\t.textBlock {\n\t\t\t// margin: 0.5rem 0 4.5rem;\n\t\t\tmargin: 0.5rem 0;\n\t\t\tgrid-template-columns: 90% 1fr;\n\t\t\talign-self: flex-start;\n\t\t\twidth: 100%;\n\t\t\tborder-radius: 0rem 2rem 2rem 1rem;\n\t\t\tz-index: 1;\n\t\t\tposition: relative;\n\n\t\t\t& > span:nth-of-type(1) {\n\t\t\t\tfont-size: 1.6rem;\n\t\t\t}\n\t\t\t& > span:nth-of-type(2) {\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: -2rem;\n\t\t\t\tright: calc(100vw / 375 * 60);\n\t\t\t\tfont-size: 1.6rem;\n\t\t\t}\n\t\t}\n\n\t\t.iconsBlock {\n\t\t\tmargin: 0 0 2rem;\n\t\t\tpadding: 3rem 1.5rem;\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 1fr 1fr;\n\t\t\tz-index: 1;\n\n\t\t\t& > div {\n\t\t\t\tmax-width: 12rem;\n\t\t\t\tfont-size: 1.5rem;\n\n\t\t\t\t& > svg {\n\t\t\t\t\twidth: calc(100vw / 375 * 40);\n\t\t\t\t\theight: calc(100vw / 375 * 40);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.img {\n\t\t\ttop: 0;\n\t\t\tright: -24%;\n\t\t\twidth: calc(100vw / 375 * 310);\n\t\t\theight: calc(100vw / 375 * 280);\n\t\t}\n\t}\n\n\t.advantagesSection {\n\t\tgap: 0;\n\n\t\t.subtitleBlock {\n\t\t\tmargin: 0 0 0 calc((100vw / 375 * 15));\n\t\t\tpadding: 2.5rem 0 4rem 2rem;\n\t\t}\n\n\t\t& > .container {\n\t\t\tmargin: -4rem 0 0;\n\t\t\tgap: 2rem;\n\n\t\t\t& > img {\n\t\t\t\tposition: relative;\n\t\t\t\tbottom: 0;\n\t\t\t\tmax-width: 48rem;\n\t\t\t\tmax-height: 42rem;\n\t\t\t\twidth: calc(100vw / 375 * 300);\n\t\t\t\theight: calc(100vw / 375 * 240);\n\t\t\t}\n\n\t\t\t& > ul {\n\t\t\t\talign-items: flex-start;\n\n\t\t\t\t& > li {\n\t\t\t\t\tfont-size: 1.8rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.instructionSection {\n\t\t& > h3 {\n\t\t\tmargin: 0 0 4rem;\n\t\t}\n\n\t\t&__content {\n\t\t\tgrid-template-columns: 1fr;\n\t\t\t& > video {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: calc((440 * 100vw) / 790);\n\t\t\t}\n\t\t}\n\t}\n\n\t.testSection {\n\t\tgrid-template-columns: 1fr;\n\t\tgrid-template-areas: 'img' 'text';\n\n\t\t& > div:nth-of-type(1) {\n\t\t\tgrid-area: text;\n\t\t}\n\t\t& > svg {\n\t\t\tgrid-area: img;\n\t\t\tmax-width: 35rem;\n\t\t\tmax-height: 33rem;\n\t\t\twidth: calc(100vw / 375 * 210);\n\t\t\theight: calc(100vw / 375 * 190);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainPage": `MainPage_mainPage__Lqjnl`,
	"container": `MainPage_container__+LDn4`,
	"subtitle": `MainPage_subtitle__bVoHM`,
	"titleSection": `MainPage_titleSection__zYfmJ`,
	"header": `MainPage_header__7rpjJ`,
	"titleBlock": `MainPage_titleBlock__TGgo+`,
	"textBlock": `MainPage_textBlock__TO225`,
	"iconsBlock": `MainPage_iconsBlock__Oka75`,
	"btn": `MainPage_btn__ZS2Uk`,
	"img": `MainPage_img__dYlPd`,
	"advantagesSection": `MainPage_advantagesSection__gVSBQ`,
	"subtitleBlock": `MainPage_subtitleBlock__PiAzH`,
	"instructionSection": `MainPage_instructionSection__gm43W`,
	"instructionSection__content": `MainPage_instructionSection__content__slGp9`,
	"testSection": `MainPage_testSection__nQfXK`
};
export default ___CSS_LOADER_EXPORT___;
